const initialState = {
    columns: {},
    filter: [],
    pageCount: -1,
    recordCount: 0,
    pageIndex: 1,
    pageSize: 20,
    sort: [],
    tasks: [],
};

const getVisibleColumnKeys = (columns) => {
    return Object.keys(columns).reduce((cArr, c) => {
        if (columns[c].value === true) {
            cArr.push(columns[c].accessor);
        }

        return cArr;
    }, []);
};

const removeHiddenFilters = (columns, filter) => {
    const visibleColumnKeys = getVisibleColumnKeys(columns);

    return filter.reduce((filteredArr, f) => {
        if (visibleColumnKeys.includes(f.id)) {
            filteredArr.push(f);
        }

        return filteredArr;
    }, []);
};
const removeHiddenSorts = (columns, sort) => {
    const visibleColumnKeys = getVisibleColumnKeys(columns);

    return sort.reduce((sortedArr, s) => {
        if (visibleColumnKeys.includes(s.id)) {
            sortedArr.push(s);
        }

        return sortedArr;
    }, []);
};

const reducer = (state, action) => {
    switch (action.type) {
        case "SET_TASKS":
            return {
                ...state,
                pageCount: action.pageCount,
                recordCount: action.recordCount,
                tasks: action.tasks,
            };
        case "SET_SETTINGS":
            return {
                ...state,
                columns: action.columns,
                filter: removeHiddenFilters(action.columns, action.filter),
                sort: removeHiddenSorts(action.columns, action.sort),
                pageSize: action.pageSize,
            };
        case "SET_COLUMNS":
            return {
                ...state,
                columns: action.columns,
                filter: removeHiddenFilters(action.columns, state.filter),
                sort: removeHiddenSorts(action.columns, state.sort),
            };
        case "SET_FILTER":
            return {
                ...state,
                filter: [...action.filter],
            };
        case "SET_PAGE":
            return {
                ...state,
                pageIndex: action.pageIndex,
                pageSize: action.pageSize,
            };
        case "SET_SORT":
            return {
                ...state,
                sort: [...action.sort],
            };
        case "UPDATE_NOTE_STATUS":
            const newTasks = state.tasks.map((t) => {
                if (t.key === action.taskId) {
                    t.hasComments = true;
                }

                return t;
            });

            return {
                ...state,
                tasks: newTasks,
            };
        default:
            return state;
    }
};

export { reducer, initialState };
